/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { adminOpenRouterKeysDisableKey } from "../funcs/adminOpenRouterKeysDisableKey.js";
import { adminOpenRouterKeysEnableKey } from "../funcs/adminOpenRouterKeysEnableKey.js";
import { adminOpenRouterKeysGetKeyUsage } from "../funcs/adminOpenRouterKeysGetKeyUsage.js";
import { adminOpenRouterKeysListKeys } from "../funcs/adminOpenRouterKeysListKeys.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { AdminOpenRouterKey } from "../models/components/adminopenrouterkey.js";
import { GetKeyUsageResponseBody } from "../models/components/getkeyusageresponsebody.js";
import { ListKeysResponseBody2 } from "../models/components/listkeysresponsebody2.js";
import {
  DisableAdminOpenRouterKeyRequest,
  DisableAdminOpenRouterKeySecurity,
} from "../models/operations/disableadminopenrouterkey.js";
import {
  EnableAdminOpenRouterKeyRequest,
  EnableAdminOpenRouterKeySecurity,
} from "../models/operations/enableadminopenrouterkey.js";
import {
  GetAdminOpenRouterKeyUsageRequest,
  GetAdminOpenRouterKeyUsageSecurity,
} from "../models/operations/getadminopenrouterkeyusage.js";
import {
  ListAdminOpenRouterKeysRequest,
  ListAdminOpenRouterKeysSecurity,
} from "../models/operations/listadminopenrouterkeys.js";
import { unwrapAsync } from "../types/fp.js";

export class AdminOpenRouterKeys extends ClientSDK {
  /**
   * disableKey adminOpenRouterKeys
   *
   * @remarks
   * Lock down an organization's platform OpenRouter key, upstream and locally. Requires platform admin.
   */
  async disableKey(
    request: DisableAdminOpenRouterKeyRequest,
    security?: DisableAdminOpenRouterKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<AdminOpenRouterKey> {
    return unwrapAsync(adminOpenRouterKeysDisableKey(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * enableKey adminOpenRouterKeys
   *
   * @remarks
   * Reinstate a disabled platform OpenRouter key, upstream and locally, keeping its recorded credit ceiling. Requires platform admin.
   */
  async enableKey(
    request: EnableAdminOpenRouterKeyRequest,
    security?: EnableAdminOpenRouterKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<AdminOpenRouterKey> {
    return unwrapAsync(adminOpenRouterKeysEnableKey(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getKeyUsage adminOpenRouterKeys
   *
   * @remarks
   * Fetch an organization's live credit usage from OpenRouter for one key. Requires platform admin.
   */
  async getKeyUsage(
    request: GetAdminOpenRouterKeyUsageRequest,
    security?: GetAdminOpenRouterKeyUsageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetKeyUsageResponseBody> {
    return unwrapAsync(adminOpenRouterKeysGetKeyUsage(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listKeys adminOpenRouterKeys
   *
   * @remarks
   * List every organization's platform OpenRouter keys. Requires platform admin.
   */
  async listKeys(
    request?: ListAdminOpenRouterKeysRequest | undefined,
    security?: ListAdminOpenRouterKeysSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListKeysResponseBody2> {
    return unwrapAsync(adminOpenRouterKeysListKeys(
      this,
      request,
      security,
      options,
    ));
  }
}
